// extracted by mini-css-extract-plugin
module.exports = {"McsTitleBase":"McsTitlePrimary_McsTitleBase__1eFrC","McsTitleTitle":"McsTitlePrimary_McsTitleTitle__3ZuT6"};